module.exports = __webpack_public_path__ + "img/address-foreign-2.8cb00b00.svg";